import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { change, Field } from "redux-form";
import { FormInput, Select } from "MODULES/shared/components/Forms";
import countries from "LIB/countries";
import { states } from "LIB/states";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import {
  CITY,
  COMPANY_NAME,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";

export const countryOptions = countries.map(c => ({
  value: c.code,
  text: c.name
}));

const renderStateField = (country, path, required) =>
  country === "US" ? (
    <Field
      name={`${path}.${STATE}`}
      component={Select}
      options={states}
      label="State/Province"
      required={required}
    />
  ) : (
    <Field
      name={`${path}.${STATE}`}
      component={FormInput}
      label="State/Province"
    />
  );

export class AddressFields extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.country && nextProps.country !== this.props.country) {
      this.props.resetStateField();
    }
  }

  render() {
    const { path, country, required } = this.props;
    return (
      <Fragment>
        <FormRow>
          <Col md={6}>
            <Field
              name={`${path}.${COMPANY_NAME}`}
              component={FormInput}
              label="Company Name"
              required={required}
            />
          </Col>
          <Col md={6}>
            <Field
              name={`${path}.${COUNTRY}`}
              component={Select}
              label="Country"
              options={countryOptions}
              required={required}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <Field
              name={`${path}.${LINE1}`}
              component={FormInput}
              label="Address Line 1"
              required={required}
            />
          </Col>
          <Col md={6}>
            <Field
              name={`${path}.${LINE2}`}
              component={FormInput}
              label="Address Line 2"
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={5}>
            <Field
              name={`${path}.${CITY}`}
              component={FormInput}
              label="City"
              required={required}
            />
          </Col>
          <Col md={4}>{renderStateField(country, path, required)}</Col>
          <Col md={3}>
            <Field
              name={`${path}.${POSTAL_CODE}`}
              component={FormInput}
              label="Zip/Postal Code"
              required={required}
            />
          </Col>
        </FormRow>
      </Fragment>
    );
  }
}

export default connect(undefined, (dispatch, ownProps) => ({
  resetStateField: () =>
    dispatch(change(ownProps.formName, `${ownProps.path}.state`, ""))
}))(AddressFields);

AddressFields.propTypes = {
  path: PropTypes.string.isRequired,
  country: PropTypes.string,
  resetStateField: PropTypes.func.isRequired,
  required: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/AddressFields.jsx